import { render, staticRenderFns } from "./MostOverdueInspectionsTableCard.vue?vue&type=template&id=ccaf25e4&"
import script from "./MostOverdueInspectionsTableCard.vue?vue&type=script&lang=js&"
export * from "./MostOverdueInspectionsTableCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports